// @flow
import React from 'react';
import { useEffectOnce } from 'react-use';
import type { Item, ItemFetcher } from './item';
import { withCreatable } from './utils/creatable';

type AsyncDropdownFilterOptions = {
  creatable?: boolean,
  previouslyCreatedItems: Array<Item>,
};

const useAsyncDropdownFilter = (
  itemFetcher: ItemFetcher,
  options: AsyncDropdownFilterOptions = {}
) => {
  const { creatable, previouslyCreatedItems } = options;
  const [items, setItems] = React.useState([]);
  const [previousSearchTerm, setPreviousSearchTerm] = React.useState();
  const [loadingStatus, setLoadingStatus] = React.useState('initial');
  const onSearchTermChange = React.useCallback(
    (newSearchTerm: string) => {
      if (previousSearchTerm === newSearchTerm) {
        return;
      }
      setPreviousSearchTerm(newSearchTerm);
      setLoadingStatus('loading');
      setItems([]);
      itemFetcher(newSearchTerm)
        .then(({ items: newItems }) => {
          setLoadingStatus('loaded');
          if (creatable) {
            setItems(
              withCreatable(newItems, newSearchTerm, previouslyCreatedItems)
            );
          } else {
            setItems(newItems);
          }
        })
        .catch((error) => {
          if (!['debounced', 'stale'].includes(error)) {
            setLoadingStatus('error');
          }
        });
    },
    [previousSearchTerm, creatable, previouslyCreatedItems, itemFetcher]
  );

  useEffectOnce(() => {
    // $FlowFixMe
    if (!itemFetcher.preventLoadOnMount) {
      onSearchTermChange('');
    }
  });

  return [items, loadingStatus, onSearchTermChange];
};

export default useAsyncDropdownFilter;
